"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireWildcard(require("react"));

var _reactRedux = require("react-redux");

var _material = require("@mui/material");

var _styles = require("@mui/styles");

var _ui = require("@alycecom/ui");

var _reactHookForm = require("react-hook-form");

var _yup = require("@hookform/resolvers/yup");

var _yup2 = require("yup");

var _hooks = require("@alycecom/hooks");

var _recipient = require("../../store/recipient/recipient.actions");

var _recipient2 = require("../../store/recipient/recipient.selectors");

var _useGetCampaignId = require("../../hooks/useGetCampaignId");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var useStyles = (0, _styles.makeStyles)(function (_ref) {
  var palette = _ref.palette;
  return {
    input: {
      borderRadius: 5
    },
    button: {
      '&.Mui-disabled, &.MuiButton-contained:hover.Mui-disabled': {
        backgroundColor: palette.grey.timberWolf
      }
    }
  };
});
var validationSchema = (0, _yup2.object)().shape({
  email: (0, _yup2.string)().label('Recipient Email').trim().email('The email must be a valid email address.').required('The email needs to be filled in.'),
  company: (0, _yup2.string)().label('Company Name').trim().nullable()
});

var AddRecipientStep = function AddRecipientStep() {
  var classes = useStyles();
  var dispatch = (0, _reactRedux.useDispatch)();
  var campaignId = (0, _useGetCampaignId.useGetCampaignId)();
  var isInProgress = (0, _reactRedux.useSelector)(_recipient2.getIsInProgress);
  var isSucceeded = (0, _reactRedux.useSelector)(_recipient2.getIsSucceeded);
  var externalErrors = (0, _reactRedux.useSelector)(_recipient2.getErrors);
  var hasExternalErrors = (0, _reactRedux.useSelector)(_recipient2.getHasErrors);

  var _useForm = (0, _reactHookForm.useForm)({
    mode: 'all',
    defaultValues: validationSchema.getDefault(),
    resolver: (0, _yup.yupResolver)(validationSchema),
    context: {
      campaignId
    }
  }),
      control = _useForm.control,
      handleSubmit = _useForm.handleSubmit,
      errors = _useForm.formState.errors,
      setError = _useForm.setError,
      reset = _useForm.reset,
      clearErrors = _useForm.clearErrors;

  (0, _hooks.useExternalErrors)(setError, externalErrors);
  (0, _hooks.useClearExternalErrors)(clearErrors, hasExternalErrors);
  var hasErrors = Object.keys(errors).length > 0;
  var isDisabled = !campaignId || hasErrors || isInProgress;
  var onSubmit = (0, _react.useCallback)(function (formValues) {
    dispatch((0, _recipient.addRecipient)(_objectSpread({
      campaignId: Number(campaignId)
    }, formValues)));
  }, [dispatch, campaignId]);
  (0, _react.useEffect)(function () {
    if (isSucceeded) {
      reset({
        email: '',
        company: ''
      });
    }
  }, [isSucceeded, reset]);
  return /*#__PURE__*/_react.default.createElement(_material.Box, null, /*#__PURE__*/_react.default.createElement(_material.Typography, {
    className: "Body-Regular-Left-White-Bold"
  }, "Step 2: Add Recipient to Campaign"), /*#__PURE__*/_react.default.createElement(_material.Box, {
    mt: 3
  }, /*#__PURE__*/_react.default.createElement(_reactHookForm.Controller, {
    control: control,
    name: "email",
    render: function render(_ref2) {
      var _errors$email;

      var field = _ref2.field;
      return /*#__PURE__*/_react.default.createElement(_material.TextField, (0, _extends2.default)({}, field, {
        label: "Recipient Email *",
        fullWidth: true,
        variant: "filled",
        error: Boolean(errors.email),
        helperText: (_errors$email = errors.email) === null || _errors$email === void 0 ? void 0 : _errors$email.message,
        className: classes.input,
        inputProps: {
          'data-testid': 'GiftingOnTheFly.RecipientEmail'
        }
      }));
    }
  })), /*#__PURE__*/_react.default.createElement(_material.Box, {
    mt: 3
  }, /*#__PURE__*/_react.default.createElement(_reactHookForm.Controller, {
    control: control,
    name: "company",
    render: function render(_ref3) {
      var _errors$company;

      var field = _ref3.field;
      return /*#__PURE__*/_react.default.createElement(_material.TextField, (0, _extends2.default)({}, field, {
        label: "Company Name",
        fullWidth: true,
        variant: "filled",
        error: Boolean(errors.company),
        helperText: (_errors$company = errors.company) === null || _errors$company === void 0 ? void 0 : _errors$company.message,
        className: classes.input,
        inputProps: {
          'data-testid': 'GiftingOnTheFly.CompanyName'
        }
      }));
    }
  })), /*#__PURE__*/_react.default.createElement(_material.Box, {
    mt: 3
  }, /*#__PURE__*/_react.default.createElement(_material.Button, {
    onClick: handleSubmit(onSubmit),
    disabled: isDisabled,
    startIcon: /*#__PURE__*/_react.default.createElement(_ui.Icon, {
      color: "inherit",
      icon: "cloud-upload-alt"
    }),
    fullWidth: true,
    variant: "contained",
    color: "secondary",
    className: classes.button,
    "data-testid": "GiftingOnTheFly.AddRecipient"
  }, "Add to Campaign")));
};

var _default = /*#__PURE__*/(0, _react.memo)(AddRecipientStep);

exports.default = _default;